import { render, staticRenderFns } from "./ocrInfoUpd.vue?vue&type=template&id=d0c998c0"
import script from "./ocrInfoUpd.vue?vue&type=script&lang=js"
export * from "./ocrInfoUpd.vue?vue&type=script&lang=js"
import style0 from "./ocrInfoUpd.vue?vue&type=style&index=0&id=d0c998c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports